import { createContext, useMemo, useReducer } from "react"
import { produce } from "immer"
import { getDefaultMetricDisplay } from "helpers/metrics"
import { usePreferences } from "hooks/use-preferences"

const PREFERENCE_SUBTYPE = "asset-view-factor-sensitivity"
const PREFERENCE_FIELDS = [
  "selectedMetricDisplay",
  "selectedCategory",
]

const DEFAULT_STATE = {
  selectedMetricDisplay: getDefaultMetricDisplay("factorSensitivity"),
  selectedCategory: "style",
}

export const FACTOR_SENSITIVITY_CONTEXT = createContext()

function reducer(current, action) {
  return produce(current, draft => {
    switch (action.type) {
      case "setSelectedMetricDisplay":
        draft.selectedMetricDisplay = action.selectedMetricDisplay
        break
      case "setSelectedCategory":
        draft.selectedCategory = action.selectedCategory
        break
      case "setPreferences":
        if (action.preferences) {
          Object.assign(draft, action.preferences)
        }
        break
    }
  })
}

function setPreferences(preferences) {
  return { type: "setPreferences", preferences }
}

export default function FactorSensitivityContext({ children }) {
  const [state, dispatch] = useReducer(reducer, DEFAULT_STATE)
  const isPreferencesLoaded = usePreferences(
    PREFERENCE_SUBTYPE,
    PREFERENCE_FIELDS,
    state,
    dispatch,
    setPreferences,
  )

  const contextUpdaters = useMemo(() => ({
    setSelectedMetricDisplay: (selectedMetricDisplay) => dispatch({ type: "setSelectedMetricDisplay", selectedMetricDisplay }),
    setSelectedCategory: (selectedCategory) => dispatch({ type: "setSelectedCategory", selectedCategory }),
  }), [dispatch])

  const contextValue = useMemo(() => ({
    ...state,
    ...contextUpdaters,
    isPreferencesLoaded,
  }), [state, contextUpdaters, isPreferencesLoaded])

  return <FACTOR_SENSITIVITY_CONTEXT.Provider value={contextValue}>
    {children}
  </FACTOR_SENSITIVITY_CONTEXT.Provider>
}
